// @core/api/endpoints/payment/create_payment_method.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePaymentMethodRequest,
  CreatePaymentMethodResponse,
} from '../../../types/payment';

const BASE_PATH = '/payment';

/**
 * Add payment method
 * Tokenizes and stores a payment method. The provider token is exchanged for a vault token, and provider-specific tokens are stored for reuse.
 */
export async function CreatePaymentMethod(
  billingAccountId: string,
  data: CreatePaymentMethodRequest,
  options?: RequestOptions
): Promise<CreatePaymentMethodResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/billing-accounts/:billingAccountId/payment-methods`;
  requestPath = requestPath.replace(':billingAccountId', encodeURIComponent(billingAccountId));
  const requestOptions = options;
  return client.post<CreatePaymentMethodResponse>(requestPath, data, requestOptions);
}
